import React from 'react'
import Container from '../../container/container'
import { useTranslation } from 'react-i18next';
import careerStyles from './careers.module.scss'

export default function Careers() {
    const { t, i18n } = useTranslation();

    return (
        <Container>
            <div className={`${careerStyles.careers} ${i18n.language === 'ar' ? careerStyles.careers_ar : ''}`}>
                <div className={careerStyles.heroSection}>
                    <div className={careerStyles.typingAnimation}>
                        {t('joinOurTeam')}
                    </div>
                </div>

                <div className={careerStyles.contentSection}>
                    <div className={careerStyles.careers_txt}>
                        <p>
                            {t('careersIntro1')}
                            <br /><br />
                        </p>

                        <p>
                            {t('careersApply1')}
                            <a href="https://www.linkedin.com/company/arab-technical" target='_blank' rel="noopener noreferrer">
                                {t('linkedIn')}
                            </a>
                            {t('careersApply2')}
                        </p>

                        <p>
                            {t('careersSendCV')}
                            <a href="mailto:careers@arabtechco.sa">careers@arabtechco.sa</a>
                        </p>
                    </div>

                    {/* <div className={careerStyles.ctaSection}>
                        <a href="mailto:careers@arabtechco.sa" className={careerStyles.ctaButton}>
                            {t('sendYourCV')}
                        </a>
                        <a href="https://www.linkedin.com/company/arab-technical"
                            target='_blank'
                            rel="noopener noreferrer"
                            className={careerStyles.linkedinButton}>
                            {t('followOnLinkedIn')}
                        </a>
                    </div> */}
                </div>
            </div>
        </Container>
    )
}